import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLBoolean,
  GraphQLEnumType,
  GraphQLNonNull
} from 'graphql'

export type UserInputType =
  | 'PARAMETER_NAME'
  | 'PARAMETER_VALUE'
  | 'HEADER'
  | 'QUERYSTRING'
  | 'BODY'
  | 'COOKIE_NAME'
  | 'COOKIE_VALUE'
  | 'URI'
  | 'SOCKET'
  | 'JSON_VALUE'
  | 'JSON_ARRAYED_VALUE'
  | 'MULTIPART_CONTENT_TYPE'
  | 'MULTIPART_VALUE'
  | 'MULTIPART_FIELD_NAME'
  | 'MULTIPART_NAME'
  | 'XML_VALUE'
  | 'DWR_VALUE'
  | 'UNKNOWN'
  | 'METHOD'
  | 'REQUEST'

const userInputType = new GraphQLEnumType({
  name: 'UserInputType',
  description: 'Methods of delivery for user input',
  values: {
    PARAMETER_NAME: {},
    PARAMETER_VALUE: {},
    HEADER: {},
    QUERYSTRING: {},
    BODY: {},
    COOKIE_NAME: {},
    COOKIE_VALUE: {},
    URI: {},
    SOCKET: {},
    JSON_VALUE: {},
    JSON_ARRAYED_VALUE: {},
    MULTIPART_CONTENT_TYPE: {},
    MULTIPART_VALUE: {},
    MULTIPART_FIELD_NAME: {},
    MULTIPART_NAME: {},
    XML_VALUE: {},
    DWR_VALUE: {},
    UNKNOWN: {},
    METHOD: {},
    REQUEST: {}
  }
})

export interface UserInput {
  readonly value: string
  readonly name: string
  readonly type: UserInputType
  readonly omittedValue: boolean
  readonly truncatedValue: boolean
}

export const userInput = new GraphQLObjectType({
  name: 'UserInput',
  fields: () => ({
    value: {
      description: 'The string value of the user input',
      type: GraphQLString
    },
    name: {
      description: 'The name of the parameter used to deliver the user input',
      type: GraphQLString
    },
    type: {
      description: 'The method of delivery for the user input',
      type: userInputType
    },
    omittedValue: {
      description: 'Was the value omitted',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    truncatedValue: {
      description: 'Was the value truncated',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})
